// DoorOperationModal.tsx
import {
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel,
  Grid,
  Button,
  Typography,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Box,
} from "@mui/material";
import { useState } from "react";

interface DoorOperationModalProps {
  open: boolean;
  handleClose: () => void;
}

const DoorOperationModal = ({ open, handleClose }: DoorOperationModalProps) => {
  const [openTime, setOpenTime] = useState(2);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent>
        <Typography variant="h6">ドア操作</Typography>
        <Box mt={2}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Button
                variant="outlined"
                color="success"
                style={{ width: "100%" }}
              >
                開く
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                variant="outlined"
                color="error"
                style={{ width: "100%" }}
              >
                閉じる
              </Button>
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel control={<Switch />} label="第二開速度設定" />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel control={<Switch />} label="第二閉速度設定" />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel control={<Switch />} label="半開設定" />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>開放時間</InputLabel>
                <Select
                  value={openTime}
                  onChange={(e) => setOpenTime(e.target.value as number)}
                  size="small"
                >
                  <MenuItem value={2}>2秒</MenuItem>
                  <MenuItem value={5}>5秒</MenuItem>
                  <MenuItem value={10}>10秒</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          キャンセル
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DoorOperationModal;
